import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/app/App';
import './index.css';
import * as Sentry from '@sentry/browser';
import { PostHogProvider } from 'posthog-js/react';

Sentry.init({
  dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
  environment: import.meta.env.VITE_PUBLIC_APP_ENV,
  initialScope: {
    tags: {
      type: 'frontend',
      projectId: import.meta.env.VITE_PUBLIC_APP_ID,
    },
  },
});

// PWA support commented out - will bring back later
// window.progressierAppRuntimeSettings = {
//   uid: import.meta.env.VITE_PUBLIC_APP_ID,
//   icon512: "https://supabase.zapt.ai/storage/v1/render/image/public/icons/c7bd5333-787f-461f-ae9b-22acbc0ed4b0/55145115-0624-472f-96b9-d5d88aae355f.png?width=512&height=512",
//   name: 'App Traction',
//   shortName: 'App Traction',
// };

// let progressierScript = document.createElement('script');
// progressierScript.setAttribute('src', 'https://progressier.app/z8yY3IKmfpDIw3mSncPh/script.js');
// progressierScript.setAttribute('defer', 'true');
// document.querySelector('head').appendChild(progressierScript);

// Analytics - only in production environment
const isProduction = import.meta.env.VITE_PUBLIC_APP_ENV === 'production';

// Umami Analytics
if (isProduction) {
  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://cloud.umami.is/script.js';
  script.setAttribute('data-website-id', import.meta.env.VITE_PUBLIC_UMAMI_WEBSITE_ID);
  document.head.appendChild(script);
}

// TikTok Pixel - load in production
if (isProduction && typeof window !== 'undefined') {
  !function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) {
      for (
        var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e
    }, ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; n = document.createElement("script")
        ; n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t; e = document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n, e)
    };

    ttq.load('D1V0VBRC77UE05RCI4R0');
    ttq.page();
  }(window, document, 'ttq');
} else if (!isProduction) {
  console.log('TikTok pixel skipped (non-production environment)');
}

// PostHog configuration
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  capture_pageview: true, // Automatically capture pageview events
  capture_pageleave: true, // Capture when users leave pages
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// Conditionally wrap with PostHog provider
const AppWrapper = () => {
  if (isProduction) {
    return (
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={posthogOptions}
      >
        <App />
      </PostHogProvider>
    );
  }
  
  return <App />;
};

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);